import { IBasePlan, IPlan, PlanAliasType } from "./types";
import { useQuery } from "@common/utils/use-query";
import { formatPlansData } from "./utils";

export function useGetPlans({ enabled } = { enabled: true }) {
  return useQuery<IBasePlan[], unknown, IPlan[]>(
    { url: "/plan" },
    {
      enabled,
      select: formatPlansData,
      refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
      refetchIntervalInBackground: true,
      refetchOnReconnect: false,
    },
  );
}

// Not used atm
export function useGetPlan(
  alias: PlanAliasType,
  { enabled } = { enabled: true },
) {
  return useQuery<IPlan>({ url: `/plan/${alias}` }, { enabled });
}
